import { makeStyles } from "@material-ui/styles";
import color from "context/MaterialUITheme/color";

export const useStyles = makeStyles(() => ({
  dayButton: {
    height: 40,
    width: 40,
    fontSize: 18,
    padding: 0,
    borderRadius: 20,
    textAlign: "center",
    cursor: "pointer",
    border: "none",
    background: "none",
  },
  invisibleDay: {
    cursor: "none",
    visibility: "hidden",
  },
  selectedDay: {
    backgroundColor: color.primary,
    color: color.white,
  },
}));
